import i from "../_virtual/intermoji.js";
var n = /* @__PURE__ */ ((t) => (t[t.None = -1] = "None", t[t.Light = 127995] = "Light", t[t.MediumLight = 127996] = "MediumLight", t[t.Medium = 127997] = "Medium", t[t.MediumDark = 127998] = "MediumDark", t[t.Dark = 127999] = "Dark", t))(n || {});
const u = i;
function c(t) {
  return u.splitOnUnicodeEmojis(t).reduce(function(o, e) {
    return o + (u.isSupportedUnicode(e) ? a(u.identifierFromUnicode(e)) : e);
  }, "");
}
function m(t) {
  return u.substituteUnicodeForColonified(t);
}
let r;
function d() {
  return r ??= u.hasNativeSupport(document), r;
}
function a(t) {
  return `:${t}:`;
}
function l() {
  r = !1;
}
function h() {
  r = !0;
}
export {
  n as SkinToneModifiers,
  l as disableNativeEmojiSupport,
  h as enableNativeEmojiSupport,
  d as hasNativeEmojiSupport,
  c as substituteColonifiedForUnicode,
  m as substituteUnicodeForColonified
};
